import type { PlacesUseCases } from '@onboarding/composition/types';
import { createPlacesApiClient } from '@onboarding/infrastructure/api';
import { createPlacesApiMapper } from '@onboarding/infrastructure/mappers';
import { createPlacesRepository } from '@onboarding/infrastructure/repositories';
import { fetchPredictionsUseCase, getPlaceDetailsUseCase } from '@onboarding/application/use-cases';

/**
 * Assembles all Places use cases with their dependencies.
 * Does not require Axios — uses Google Maps SDK directly.
 */
export const createPlacesUseCases = (): PlacesUseCases => {
  const apiClient = createPlacesApiClient();
  const mapper = createPlacesApiMapper();
  const placesPort = createPlacesRepository({ apiClient, mapper });

  return {
    fetchPredictions: fetchPredictionsUseCase({ placesPort }),
    getPlaceDetails: getPlaceDetailsUseCase({ placesPort }),
  };
};
